// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ur9i","field":"styles_field__3rmZZ","fieldCol":"styles_fieldCol__2OXIQ","diffCol":"styles_diffCol__3MdhQ","diff":"styles_diff__K7MtH"};